import {
  UNAUTHORISED_ADVERTISEMENTS,
  UNAUTHORISED_CHANGE_OF_USE,
  UNAUTHORISED_INSTALLATION,
  UNAUTHORISED_WORKS,
  BREACH_OF_PLANNING,
  SHORT_TERM_LETS,
} from '../constants/constants';

const unauthorisedAdvertisementsContent = (
  <div className="text-bodyLg mt-2 flex flex-col gap-4">
    <p>This includes things you need permission to display like:</p>
    <ul className="ml-6 flex list-disc flex-col">
      <li>commercial signs</li>
      <li>banners</li>
      <li>posters</li>
      <li>building wraps or shrouds</li>
    </ul>
  </div>
);

const unauthorisedChangeContent = (
  <div className="text-bodyLg mt-2 flex flex-col gap-4">
    <p>
      This means a property is being used differently from what it has planning
      permission for.{' '}
    </p>
    <p>
      For example, a shop changing into a hot food takeaway without planning
      permission.
    </p>
  </div>
);

const unauthorisedInstallationContent = (
  <div className="text-bodyLg mt-2 flex flex-col gap-4">
    <p>
      This includes equipment installed without planning permission, such as:
    </p>
    <ul className="ml-6 flex list-disc flex-col">
      <li>air conditioning units</li>
      <li>extract ducts</li>
      <li>air source heat pumps</li>
      <li>machinery</li>
    </ul>
  </div>
);

const unauthorisedWorksContent = (
  <div className="text-bodyLg mt-2 flex flex-col gap-4">
    <p>
      This includes building works that need planning permission or listed
      building consent but do not have it. For example:
    </p>
    <ul className="ml-6 flex list-disc flex-col">
      <li>building extensions or changes to layout</li>
      <li>demolition</li>
      <li>changes to windows or doors on listed buildings</li>
    </ul>
  </div>
);

const planningBreachContent = (
  <div className="text-bodyLg mt-2 flex flex-col gap-4">
    <p>
      This means a development has planning permission but the planning
      conditions or rules attached to it haven’t been followed. For example:
    </p>
    <ul className="ml-6 flex list-disc flex-col">
      <li>working outside the allowed hours</li>
      <li>not installing screening or planting as required</li>
      <li>going above noise limits</li>
    </ul>
  </div>
);

const ShortTermLetsContent = (
  <div className="text-bodyLg mt-2 flex flex-col gap-4">
    <p>
      This means a property is being rented out for short stays without meeting
      planning rules. For example, renting out a residential home for more than
      90 nights a year.
    </p>
  </div>
);

const issueInfoData = [
  {
    id: UNAUTHORISED_ADVERTISEMENTS,
    title: 'Unauthorised advertisements',
    descriptionInfo: unauthorisedAdvertisementsContent,
  },
  {
    id: UNAUTHORISED_CHANGE_OF_USE,
    title: 'Unauthorised change of use',
    descriptionInfo: unauthorisedChangeContent,
  },
  {
    id: UNAUTHORISED_INSTALLATION,
    title: 'Unauthorised installation of plant or equipment',
    descriptionInfo: unauthorisedInstallationContent,
  },
  {
    id: UNAUTHORISED_WORKS,
    title: 'Unauthorised works, including to listed buildings',
    descriptionInfo: unauthorisedWorksContent,
  },
  {
    id: BREACH_OF_PLANNING,
    title: 'Breach of planning conditions',
    descriptionInfo: planningBreachContent,
  },
  {
    id: SHORT_TERM_LETS,
    title: 'Short-term lets',
    descriptionInfo: ShortTermLetsContent,
  },
];

export default issueInfoData;
